module.exports = __webpack_public_path__ + "img/ch16_08_假恩人.00a36c96.jpg";